import { render } from "./SentenceAssemblyPrefilledComponent.vue?vue&type=template&id=37a46101&scoped=true"
import script from "./SentenceAssemblyPrefilledComponent.vue?vue&type=script&lang=js"
export * from "./SentenceAssemblyPrefilledComponent.vue?vue&type=script&lang=js"

import "./SentenceAssemblyPrefilledComponent.vue?vue&type=style&index=0&id=37a46101&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a46101"]])

export default __exports__